// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"097ed04e","602":"b758e5ac"}[chunkId] + ".chunk.js";
};